import React from "react"
import JuicerFeedBlade from "@organic-return/foundation-react/src/components/Blades/JuicerFeedBlade"

const JuicerFeed = ({ module }) => {
    const fields = module.customFields

    let blockHeightClass = "h-fit"
    fields.height == "screen" && (blockHeightClass = "h-fit md:min-h-screen")

    let inverted = ""
    fields.inverted == "true" && (inverted = "inverted")

    let links: any[] = []
    if (fields.cTALink1?.href || fields.cTALink2?.href) {
        fields.cTALink1?.href && links.push({
            href: fields.cTALink1.href,
            label: fields.cTALink1.text,
            target: fields.cTALink1.target,
        })

        fields.cTALink2?.href && links.push({
            href: fields.cTALink2.href,
            label: fields.cTALink2.text,
            target: fields.cTALink2.target,
        })
    }

    return (
        <>
            <section className={`juicer-feed-module relative w-full py-10 ${blockHeightClass} ${inverted}`}>
                {fields.title &&
                    <h2 className="text-center">{fields.title}</h2>
                }
                {fields.text &&
                    <div className="relative mx-auto max-w-6xl px-4 pb-7 pt-2" dangerouslySetInnerHTML={{ __html: fields.text }}></div>
                }
                <JuicerFeedBlade className="relative block" juicerId={fields.juicerId}></JuicerFeedBlade>
                {links.length > 0 &&
                    <div className="max-w-6xl relative mx-auto flex flex-col items-center gap-y-2 md:flex-row md:justify-around pt-12 pb-4">
                        {links.map((link, index) => (
                            <a key={index}
                                target={link.target}
                                href={link.href}
                                className="uppercase font-bold m-0.5 px-5 py-2 no-underline text-base text-button-text bg-button-bg hover:text-action-hover">
                                {link.label}
                            </a>
                        ))}
                    </div>
                }

            </section>
        </>
    )
}

export default JuicerFeed